<template>
  <div
    class="rounded-xl border border-[#F3F3F3] font-roboto"
    :class="{ expanded: isExpanded }"
  >
    <div class="announce" @click="toggleExpanded">
      <div class="icon_wrapper">
        <SvgIcon class="icon" :name="isExpanded ? 'minus' : 'plus'" />
      </div>
      <div>{{ bookshelf.title }}</div>
    </div>
    <div class="books">
      <div class="overflow-hidden px-5">
        <div
          v-for="(book, index) in bookshelf.books"
          :key="index"
          class="flex border-b border-[#F3F3F3] px-5 py-4 last:border-none"
        >
          <div class="book-item" :data-counter="`${index + 1}.`">
            <div
              v-if="book.title"
              class="mb-1 text-base font-medium leading-5 text-[#1F1F1F]"
            >
              {{ book.title }}
            </div>
            <div v-if="book.author" class="text-sm font-normal leading-4">
              {{ book.author }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  bookshelf: {
    type: Object,
    required: true,
  },
  expanded: {
    type: Boolean,
    default: false,
  },
});

const isExpanded = ref(props.expanded);

const toggleExpanded = () => {
  isExpanded.value = !isExpanded.value;
};
</script>

<style scoped lang="scss">
.announce {
  @apply flex items-center p-7 cursor-pointer transition-colors duration-500;
  @apply text-lg leading-[22px] font-medium text-[#1F1F1F];
  @apply border-b border-[transparent];
  .expanded & {
    @apply border-[#F3F3F3];
  }
}

.books {
  @apply grid transition-all duration-500 grid-rows-[0fr];
  .book-item {
    @apply relative pl-[46px] -ml-2;
    &::before {
      content: attr(data-counter);
      @apply text-base leading-5 font-medium text-[#ABABAB];
      @apply absolute left-0 top-0 w-[46px] pr-2 text-right select-all;
    }
  }
  .expanded & {
    @apply grid-rows-[1fr];
  }
}

.icon_wrapper {
  @apply w-4 h-4 flex items-center justify-center mr-2 rounded bg-[#A10009];
  > .icon {
    @apply text-white-100;
  }
  .expanded & {
    @apply bg-[#f3e0e1];
    > .icon {
      @apply text-[#A10009];
    }
  }
}
</style>
